import React, { useState } from "react";
import { List, ListItem, ListItemIcon, ListItemText, IconButton, FormControl, InputBase, InputAdornment, Typography } from "@material-ui/core";
import { Search } from "@material-ui/icons";

export const FormAddNode = ({fmk, formData}) => {
  
  const [ filtroCategoria, setFiltroCategoria ] = useState(() => "");
  const [ filtro, setFiltro ] = useState(() => "");
  const tiposNodos = formData.nodeTypes;
  
  const itemSelect = {
    backgroundColor: "var(--color-oqt-active)",
    color: "white",
    fill: "white",
  }

  const handleChangeFiltro = (value) => {
    setFiltro(value);
  }

  const handleTipoNodoClick = ({categoria, tipo}) => {
    //console.log("handleTipoNodoClick", {categoria, tipo})
    fmk.setValues(getDefaultValues({categoria, tipo}));
    fmk.submitForm();
  }

  return (
    <>
      <div style={{ overflowY: "auto", display: "flex", flexDirection: "row", flex: 1 }}>
        <List style={{width: 275}}>
          {tiposNodos.map((categoria, index) => (
            <ListItem style={categoria.nombre === filtroCategoria ? itemSelect : {}} button key={categoria.nombre} onClick={() => setFiltroCategoria(filtro => filtro === categoria.nombre ? "" : categoria.nombre)}>
              <ListItemIcon dangerouslySetInnerHTML={{__html: categoria.icono}}>
              </ListItemIcon>
              <ListItemText primary={categoria.nombre} />
            </ListItem>
          ))}
        </List>
        <div style={{padding: 10, display: "flex", flexDirection: "column", flex: 1}}>
          <FormControl
            variant="outlined" 
            style={{
              width: "100%",
              backgroundColor: "#f7f7f7",
              padding: "6px 4px 4px 8px",
              borderRadius: 2,
              marginBottom: 8,
            }} 
          >
            <InputBase 
              size="small" 
              type="text" 
              autoFocus={true} 
              endAdornment={
                <InputAdornment position="start">
                  <IconButton
                    aria-label="toggle password visibility"
                    edge="end"
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              }
              onChange={e => handleChangeFiltro(e.target.value)}
              value={filtro}
              placeholder="Filtro"
            />
          </FormControl>          
          <div style={{padding: 10, display: "flex", flexDirection: "column", maxHeight: "450px", minHeight: "450px", height: "450px", overflowY: "auto"}}>

            {tiposNodos
              .filter(categoria => filtroCategoria === "" || categoria.nombre === filtroCategoria)
              .map((categoria, indexCategoria) => {
                const tipos = categoria
                  .tipos
                  .filter(tipo => !filtro || tipo.titulo?.toLowerCase().includes(filtro.toLowerCase()) || tipo.descripcion?.toLowerCase().includes(filtro.toLowerCase()))
                return (
                  <div style={{marginTop: 10}} key={indexCategoria}>
                    <span style={{fontSize: 16}} >{categoria.titulo}</span>
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gridAutoRows: "1fr",
                    }}>
                      {
                        tipos.length === 0 
                        ? <span style={{color: "#ababab"}}>No hay nada por acá</span>
                        : <>{tipos.map((tipo, indexTipo) => 
                          <TipoNodo key={indexTipo} fontColor={categoria.fontColor} bgColor={categoria.bgColor} {...tipo} onClick={()=>handleTipoNodoClick({categoria, tipo})} />
                        )}</>
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </>
  )
}


const TipoNodo = ({bgColor, fontColor, titulo, descripcion, onClick}) => {

  const [scale, setScale] = useState(1);

  const handleMouseEnter = () => {
    setScale(1.05)
  }

  const handleMouseOut = () => {
    setScale(1)
  }

  return (
    <div 
      onClick={onClick}
      onMouseOver={handleMouseEnter}
      onMouseOut={handleMouseOut}
      style={{
        display: "flex", 
        flexDirection: "column",
        height: 100,
        borderRadius: 5,
        backgroundColor: bgColor || "#0D0D0D",
        padding: 8,
        margin: 4, 
        cursor: "pointer",
        transform: `scale(${scale})`,
        transition: "transform 0.1s ease 0s",
        color: fontColor || "white"
      }}
    >
      <Typography variant="h6">{titulo}</Typography>
      <Typography variant="body2">{descripcion}</Typography>
    </div>

  )

}

export const getDefaultValues = ({categoria, tipo}) => {
  const {descripcion, idTipoNodo, nombre, titulo, id, tipoNodo, tipoNodoFuncional, bgColor, fontColor, ...tipoProps} = tipo
  const defaultValues = {
    nombre,
    idTipo: tipo.id,
    tipoNodo: tipoNodo || categoria.tipoNodo,
    tipoNodoFuncional: tipoNodoFuncional || categoria.tipoNodoFuncional,
    bgColor: bgColor || categoria.bgColor,
    fontColor: fontColor || categoria.fontColor,
    nombreOriginal: tipo.nombre,
    _tipo: tipo,
  }

  switch (defaultValues.tipoNodo) {
    case "NodeBasic":
      return {
        ...defaultValues,           
        ...tipoProps,
        fields: tipoProps.fields.map(x => ({...x, id: 0, idParametro: x.id, value: null}))
      };
      break;
    case "NodeUI":
      return {
        ...defaultValues,           
        ...tipoProps,
        fields: tipoProps.fields.map(x => ({...x, id: 0, idParametro: x.id, value: null}))
      };
      break;
    default:
      return {
        ...defaultValues,           
        ...tipoProps            
      };
      break;
  }
}
